import { render } from "./icon.vue?vue&type=template&id=7c056072"
import script from "./icon.vue?vue&type=script&lang=js"
export * from "./icon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/map-here/markers/icon.vue'],['render',render],['__file',"icon.vue"]])

export default __exports__